import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosClient, { getData, postData } from '../global/Globalapi';
import { CiHeart } from "react-icons/ci";
import { FaHeart } from "react-icons/fa";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import EnhancedSearchBar from './DynamicComp/EnhancedSearchBar ';
import { FiFilter } from "react-icons/fi";
// ✅ FIXED: Changed prop name from ProductCategoryId to categoryId to match Header1
const Demo_3 = ({ categoryId , showOnlyFeatured = false}) => {
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();
  const baseURL = axiosClient.defaults.baseURL;
  const [likedProducts, setLikedProducts] = useState({});
const [allProducts, setAllProducts] = useState([]);
const [displayProducts, setDisplayProducts] = useState([]);
const scrollRef = useRef(null);

  // useEffect(() => {
  //   // ✅ FIXED: Use categoryId instead of ProductCategoryId
  //   if (categoryId === undefined || categoryId === null) return;


  //   const fetchProducts = async () => {
  //     try {
  //       // ✅ This API call should work with product_category_id
  //       const res = await getData(`/product/category/${categoryId}`);
  //       if (res) {
  //         setProducts(res.data);
  //       }
  //     } catch (error) {
  //       console.error('Failed to fetch filtered products:', error);
  //     }
  //   };

  //   fetchProducts();
  // }, [categoryId]); // ✅ FIXED: Updated dependency

  // Check wishlist status for all fetched products
// useEffect(() => {
//   const fetchProducts = async () => {
//     try {
//       let res;

//       // ✅ NO CATEGORY → SHOW ALL
//      if (categoryId === undefined || categoryId === null) 
//   {
//         res = await getData("/all");
//         console.log("✅ Showing ALL products:", res.data.length);
//         setProducts(res.data);
//         return;
//       }

//       // ✅ CATEGORY SELECTED
//       res = await getData(`/product/category/${categoryId}`);
//       console.log("✅ Showing CATEGORY products:", res.data.length);
//       setProducts(res.data);

//     } catch (err) {
//       console.error("❌ Product fetch failed", err);
//     }
//   };

//   fetchProducts();
// }, [categoryId]);


useEffect(() => {
  const fetchProducts = async () => {
    try {
      let res;

      if (showOnlyFeatured) {
        res = await getData("/all");
      } else if (categoryId === undefined || categoryId === null) {
        return;
      } else {
        res = await getData(`/product/category/${categoryId}`);
      }

      if (res) {
        setProducts(res.data || []);
      }
    } catch (error) {
      console.error("Failed to fetch filtered products:", error);
    }
  };

  fetchProducts();
}, [categoryId, showOnlyFeatured]);
// useEffect(() => {
//   if (!scrollRef.current || products.length === 0 || !showOnlyFeatured) return;

//   const container = scrollRef.current;

//   const autoScroll = setInterval(() => {
//     container.scrollLeft += 1;

//     if (container.scrollLeft + container.clientWidth >= container.scrollWidth) {
//       container.scrollLeft = 0;
//     }
//   }, 20);

//   return () => clearInterval(autoScroll);
// }, [products, showOnlyFeatured]);
 
useEffect(() => {
  if (!scrollRef.current || products.length === 0 || !showOnlyFeatured) return;

  const container = scrollRef.current;

  const autoScroll = setInterval(() => {
    container.scrollLeft += 1;

    // 🔁 smooth loop (no jump)
    if (container.scrollLeft >= container.scrollWidth / 2) {
      container.scrollLeft = 0;
    }
  }, 20);

  return () => clearInterval(autoScroll);
}, [products, showOnlyFeatured]);
useEffect(() => {
    const checkWishlistStatus = async () => {
      const userString = localStorage.getItem("user");
      const users = userString ? JSON.parse(userString) : null;
      const userId = users?.id || null;

      if (!userId || products.length === 0) {
        return;
      }

      const newLikedStatus = {};
      for (const product of products) {
        try {
          const res = await postData("/check", { 
            product_id: product.product_id, 
            user_id: userId 
          });
          if (res.status === 200) {
            newLikedStatus[product.product_id] = true;
          } else {
            newLikedStatus[product.product_id] = false;
          }
        } catch (error) {
          console.error("Error checking wishlist status for product:", product.product_id, error);
          newLikedStatus[product.product_id] = false;
        }
      }
      setLikedProducts(newLikedStatus);
    };

    checkWishlistStatus();
  }, [products]);

  // const handleAddToCart = (productId) => {
  //   navigate(`/product/${productId}`);
  // };
const handleAddToCart = (productId) => {
  const encodedId = btoa(productId.toString()); // Encode product ID (e.g. 1 -> MQ==)
  navigate(`/product/${encodedId}`);
};
// const handleAddToCart = (productId) => {
//   const encodedId = btoa(productId.toString()); // Encode product ID

//   // 🧠 Manually assign user_id and campaign_id here
//   const userId = 101; // Replace this with dynamic ID later if needed
//   const campaignId = 12; // Replace this with your dynamic campaign ID

//   // ✅ Append them as URL query parameters
//   navigate(`/product/${encodedId}?user_id=${userId}&campaign_id=${campaignId}`);
// };
// const handleAddToCart = async (productId) => {
//   try {
//     const encodedId = btoa(productId.toString()); // Encode product ID

//     // Replace these with dynamic values later if needed
//     const userId = 101;
//     const campaignId = 12;

//     // ✅ Prepare data to insert into the campaign_leads table
//     const leadData = {
//       user_id: userId,
//       campaign_id: campaignId,
//       product_id: productId,
//     };

//     // ✅ Send data to backend
//     const response = await postData("api/campaign_leads", leadData);

//     if (response.data.status === "success") {
//       console.log("🎉 Lead inserted successfully:", response.data);
//     } else {
//       console.warn("⚠️ Failed to insert lead:", response.data.message);
//     }

//     // ✅ Navigate after storing lead
//     navigate(`/product/${encodedId}?user_id=${userId}&campaign_id=${campaignId}`);
//   } catch (error) {
//     console.error("❌ Error adding to cart:", error);
//   }
// };
// const handleAddToCart = async (productId) => {
//   try {
//     const encodedId = btoa(productId.toString()); // Encode product ID

//     // Replace these with dynamic values later if needed
//     const userId = 101;
//     const campaignId = 12;

//     // ✅ Prepare data to insert into the campaign_leads table
//     const leadData = {
//       user_id: userId,
//       campaign_id: campaignId,
//       product_id: productId,
//     };

//     // ✅ Send data to backend (uses axios helper)
//     const response = await postData("/campaign_leads", leadData);

//     // ✅ Handle response
//     if (response.data.status === "success") {
//       console.log("🎉 Lead inserted successfully:", response.data);
//     } else {
//       console.warn("⚠️ Failed to insert lead:", response.data.message);
//     }

//     // ✅ Navigate after storing lead
//     navigate(`/product/${encodedId}?user_id=${userId}&campaign_id=${campaignId}`);
//   } catch (error) {
//     console.error("❌ Error adding to cart:", error);
//   }
// };

  const handleWishlist = async (productId) => {
    const userString = localStorage.getItem("user");
    const user = userString ? JSON.parse(userString) : null;
    // const userId = users?.id || null;

    if (!user) {
      toast.error("Please log in to add to wishlist.");
      return;
    }

    try {
      const res = await postData("/update-wish", { 
        user_id: user.user_id, 
        product_id: productId 
      });

      
      if (res && res.status === 200) {
        setLikedProducts(prev => {
          const isCurrentlyLiked = prev[productId];
          toast.success(isCurrentlyLiked ? "Removed from wishlist." : "Added to wishlist.");
          return {
            ...prev,
            [productId]: !isCurrentlyLiked
          };
        });
      } else {
        toast.error("Failed to update wishlist.");
      }
    } catch (error) {
      toast.error("Failed to update wishlist.");
      console.error("Wishlist API error:", error);
    }
  };

  // ✅ Added: Show message when no products found
  // if (!categoryId) {
  //   return (
  //     <div className="py-6 px-6 md:px-16">
  //       <h2 className="text-3xl font-bold mb-8 text-center">Featured Products</h2>
  //       <p className="text-center text-gray-500">Select a category to view products</p>
  //     </div>
  //   );
  // }
if (!categoryId && !showOnlyFeatured) {
  return (
    <div className="py-6 px-6 md:px-16">
      <h2 className="text-3xl font-bold mb-8 text-center">Featured Products</h2>
      <p className="text-center text-gray-500">Select a category to view products</p>
    </div>
  );
}
  if (products.length === 0) {
    return (
      <div className="py-6 px-6 md:px-16">
        <h2 className="text-3xl font-bold mb-8 text-center">Featured Products</h2>
        <p className="text-center text-gray-500">No products found in this category</p>
      </div>
    );
  }
// const featuredProducts = products.filter(
//   product => product.Feature_product === 1
// );

// const normalProducts = products.filter(
//   product => product.Feature_product !== 1
// );
const featuredProducts = products.filter(
  product => Number(product.Feature_product) === 1
);

const normalProducts = products.filter(
  product => Number(product.Feature_product) !== 1
);
// const normalProducts = products.filter(
//   product => Number(product.Feature_product) !== 1
// );

//   return (
//     <div className="py-6 px-6 md:px-16">
//       {/* <h2 className="text-3xl font-bold mb-8 text-center">Featured Products</h2> */}
//         <h2 className="text-3xl font-bold mb-8 text-center">Product list</h2>
//       <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
//         {products.map((product) => (
//           // <div 
//           //   key={product.product_id} 
//           //   className="bg-white rounded-lg shadow hover:shadow-xl transition relative"
//           // >
//           <div 
//   key={product.product_id}
//   className={`bg-white rounded-lg shadow hover:shadow-xl transition relative 
//     ${product.Feature_product === 1 ? "ring-2 ring-yellow-400" : ""}
//   `}
// >
// <div className="relative">
//   {/* ⭐ Featured Badge */}
//   {product.Feature_product === 1 && (
//     <div className="absolute top-2 left-2 bg-yellow-500 text-white text-xs font-bold px-2 py-1 rounded z-10">
//       Featured
//     </div>
//   )}
//             {/* <img
//               src={
//                 product.image_file
//                   ? `${baseURL}/uploads/${product.image_file}`
//                   : 'https://via.placeholder.com/300x200?text=No+Image'
//               }
//               alt={product.product_name}
//               className="w-full h-48 object-cover rounded-t-lg"
//             /> */}
//             <img
//   src={
//     product.image_file
//       ? `${baseURL}/uploads/${product.image_file}`
//       : 'https://via.placeholder.com/300x200?text=No+Image'
//   }
//   alt={product.product_name}
//   className="w-full h-48 object-cover rounded-t-lg"
// />

            
//             {/* Wishlist icon */}
//             <div
//               className="absolute top-2 right-2 cursor-pointer text-white z-10"
//               onClick={() => handleWishlist(product.product_id)}
//             >
//               {likedProducts[product.product_id] ? (
//                 <FaHeart size={24} className="text-red-500" />
//               ) : (
//                 <CiHeart size={24} className="text-gray-500" />
//               )}
//             </div>
// </div>
//             <div className="p-4 text-center">
//               <h3 className="font-semibold mb-2">{product.product_name}</h3>
//               <p className="text-blue-600 font-bold mb-2">₹{product.price}</p>
//               <button
//                 className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
//                 onClick={() => handleAddToCart(product.product_id)}
//               >
//                 Add to Cart
//               </button>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// const getDisplayPrice = (product) => {
//   // If product has variant/batch
//   if (product.has_variant === 1) {
//     return product.unit_selling_price;
//   }

//   // If no variant/batch
//   return product.unit_selling_price;
  
// };
const getDisplayPrice = (product) => {
  const price =
    product.has_variant === 1
      ? product.unit_selling_price
      : product.unit_selling_price;

  return parseFloat(price || 0).toFixed(2);
};
// return (
  
  
//   <div className="py-6 px-6 md:px-16">


//     {/* 🔍 HEADER SEARCH BAR */}
//     <div className="mb-10 flex justify-center">
//       {/* <EnhancedSearchBar /> */}
//       <div className="flex items-center gap-3 ">
//     {/* <div className="flex items-center gap-3 w-[220px] sm:w-[280px] "> */}
//     <EnhancedSearchBar />

//     <button
//       onClick={() => navigate("/shopping")}
//       className="
//         flex items-center gap-2
//         bg-orange-500 text-white
//         px-4 py-2 rounded-lg
//         hover:bg-orange-600
//         transition
//         whitespace-nowrap
//       "
//     >
//       <FiFilter size={18} />
//       <span className="hidden sm:inline">Filter</span>
//     </button>
//   </div>
//     </div>
    
//     {/* 📦 ALL PRODUCTS FIRST */}
//     <h2 className="text-3xl font-bold mb-8 text-center">
//      Products List
//     </h2>

//     <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16">
//       {products.map((product) => (
//         <div
//           key={product.product_id}
//           className="bg-white rounded-lg shadow hover:shadow-xl transition"
//         >
//           <div className="relative">
//             <img
//               src={
//                 product.image_file
//                   ? `${baseURL}/uploads/${product.image_file}`
//                   : 'https://via.placeholder.com/300x200?text=No+Image'
//               }
//               alt={product.product_name}
//               className="w-full h-48 object-cover rounded-t-lg"
//             />

//             <div
//               className="absolute top-2 right-2 cursor-pointer z-10"
//               onClick={() => handleWishlist(product.product_id)}
//             >
//               {likedProducts[product.product_id] ? (
//                 <FaHeart size={24} className="text-red-500" />
//               ) : (
//                 <CiHeart size={24} className="text-gray-500" />
//               )}
//             </div>
//           </div>

//           <div className="p-4 text-center">
//             {/* <h3 className="font-semibold mb-2">{product.product_name}</h3> */}
//             <h3 className="text-sm font-medium text-center md:text-left px-2">
//   {product.product_name}
// </h3>

//             {/* <p className="text-blue-600 font-bold mb-2">₹{product.price}</p> */}
//             <p className="text-blue-600 font-bold mb-2">
//   ₹{getDisplayPrice(product)}
// </p>

//             <button
//               className="text-white px-4 py-2 bg-[#c97c5d] rounded hover:bg-orange-300"
//               onClick={() => handleAddToCart(product.product_id)}
//             >
//               View
//             </button>
//           </div>
//         </div>
//       ))}
//     </div>

//     {/* ⭐ FEATURED PRODUCTS AFTER */}
//     {/* {featuredProducts.length > 0 && ( */}
//       {/* <> */}
//        {/* <h2 className="text-3xl font-bold mb-8 text-center"> */}
//            {/* Featured Products List */}
//         {/* </h2> */}

//         {/* <div className="grid grid-cols-2 md:grid-cols-4 gap-6"> */}
//           {/* {featuredProducts.map((product) => ( */}
//             {/* <div */}
//               {/* key={product.product_id} */}
//               {/* className="bg-white rounded-lg shadow hover:shadow-xl transition ring-2 ring-yellow-400" */}
//             {/* > */}
//               {/* <div className="relative">
//                 <div className="absolute top-2 left-2 bg-yellow-500 text-white text-xs font-bold px-2 py-1 rounded z-10">
//                   Featured
//                 </div> */}

//                 {/* <img
//                   src={
//                     product.image_file
//                       ? `${baseURL}/uploads/${product.image_file}`
//                       : 'https://via.placeholder.com/300x200?text=No+Image'
//                   }
//                   alt={product.product_name}
//                   className="w-full h-48 object-cover rounded-t-lg"
//                 /> */}

//                 {/* <div
//                   className="absolute top-2 right-2 cursor-pointer z-10"
//                   onClick={() => handleWishlist(product.product_id)}
//                 > */}
//                   {/* {likedProducts[product.product_id] ? (
//                     <FaHeart size={24} className="text-red-500" />
//                   ) : (
//                     <CiHeart size={24} className="text-gray-500" />
//                   )} */}
//                 {/* </div> */}
//               {/* </div> */}

//               {/* <div className="p-4 text-center"> */}
//                 {/* <h3 className="font-semibold mb-2">{product.product_name}</h3>
//                 <h3 className="text-sm font-medium text-center md:text-left px-2">
//   {product.product_name}
// </h3> */}

//                 {/* <p className="text-blue-600 font-bold mb-2">₹{product.price}</p> */}
//                 {/* <p className="text-blue-600 font-bold mb-2">
//   ₹{getDisplayPrice(product)}
// </p> */}

//                 {/* <button
//                   className="text-white px-4 py-2 rounded hover:bg-orange-300"
//                   onClick={() => handleAddToCart(product.product_id)}
//                 >
//                  View
//                 </button>
//               </div> */}
//             {/* </div> */}
//           {/* ))} */}
//         {/* </div> */}
//       {/* </> */}
//     {/* // )} */}
//  {/* ⭐ FEATURED PRODUCTS AFTER */}
//     {featuredProducts.length > 0 && (
//       <>
//        <h2 className="text-3xl font-bold mb-8 text-center">
//            Featured Products List
//         </h2>

//         <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
//           {featuredProducts.map((product) => (
//             <div
//               key={product.product_id}
//               className="bg-white rounded-lg shadow hover:shadow-xl transition ring-2 ring-yellow-400"
//             >
//               <div className="relative">
//                 <div className="absolute top-2 left-2 bg-yellow-500 text-white text-xs font-bold px-2 py-1 rounded z-10">
//                   Featured
//                 </div>

//                 <img
//                   src={
//                     product.image_file
//                       ? `${baseURL}/uploads/${product.image_file}`
//                       : 'https://via.placeholder.com/300x200?text=No+Image'
//                   }
//                   alt={product.product_name}
//                   className="w-full h-48 object-cover rounded-t-lg"
//                 />

//                 <div
//                   className="absolute top-2 right-2 cursor-pointer z-10"
//                   onClick={() => handleWishlist(product.product_id)}
//                 >
//                   {likedProducts[product.product_id] ? (
//                     <FaHeart size={24} className="text-red-500" />
//                   ) : (
//                     <CiHeart size={24} className="text-gray-500" />
//                   )}
//                 </div>
//               </div>

//               <div className="p-4 text-center">
//                 {/* <h3 className="font-semibold mb-2">{product.product_name}</h3> */}
//                 <h3 className="text-sm font-medium text-center md:text-left px-2">
//   {product.product_name}
// </h3>

//                 {/* <p className="text-blue-600 font-bold mb-2">₹{product.price}</p> */}
//                 <p className="text-blue-600 font-bold mb-2">
//   {/* ₹{getDisplayPrice(product)} */}
//    ₹{Number(getDisplayPrice(product)).toFixed(2)}
// </p>

//                 <button
//                   className=" text-white px-4 py-2 rounded bg-[#c97c5d]  hover:bg-orange-300"
//                   onClick={() => handleAddToCart(product.product_id)}
//                 >
//                 View
//                 </button>
//               </div>
//             </div>
//           ))}
//         </div>
//       </>
//     )}

//   </div>
// );
const featuredScrollProducts =
  featuredProducts.length > 4
    ? [...featuredProducts, ...featuredProducts]
    : featuredProducts;
return (
  <div className="py-6 px-6 md:px-16">
    {!showOnlyFeatured && (
      <>
        {/* 🔍 HEADER SEARCH BAR */}
        <div className="mb-10 flex justify-center">
          <div className="flex items-center gap-3">
            <EnhancedSearchBar />

            <button
              onClick={() => navigate("/shopping")}
              className="
                flex items-center gap-2
                bg-orange-500 text-white
                px-4 py-2 rounded-lg
                hover:bg-orange-600
                transition
                whitespace-nowrap
              "
            >
              <FiFilter size={18} />
              <span className="hidden sm:inline">Filter</span>
            </button>
          </div>
        </div>

        {/* 📦 NORMAL PRODUCTS */}
        <h2 className="text-3xl font-bold mb-8 text-center">
          Products List
        </h2>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16">
          {/* {normalProducts.map((product) => ( */}
          {products.map((product) => (
            <div
              key={product.product_id}
              className="bg-white rounded-lg shadow hover:shadow-xl transition"
            >
              <div className="relative">
                <img
                  src={
                    product.image_file
                      ? `${baseURL}/uploads/${product.image_file}`
                      : "https://via.placeholder.com/300x200?text=No+Image"
                  }
                  alt={product.product_name}
                  className="w-full h-48 object-cover rounded-t-lg"
                />

                <div
                  className="absolute top-2 right-2 cursor-pointer z-10"
                  onClick={() => handleWishlist(product.product_id)}
                >
                  {likedProducts[product.product_id] ? (
                    <FaHeart size={24} className="text-red-500" />
                  ) : (
                    <CiHeart size={24} className="text-gray-500" />
                  )}
                </div>
              </div>

              <div className="p-4 text-center">
                <h3 className="text-sm font-medium text-center md:text-left px-2">
                  {product.product_name}
                </h3>

                {/* <p className="text-blue-600 font-bold mb-2">
                  ₹{getDisplayPrice(product)}
                </p> */}
                <div className="flex items-center justify-center gap-2 mb-2">
  {/* Selling Price */}
  <span className="text-blue-600 font-bold">
    ₹{Number(product.unit_selling_price || 0).toFixed(2)}
  </span>

  {/* MRP Price */}
  {product.mrp_price && (
    <span className="text-red-500 text-sm line-through">
      ₹{Number(product.mrp_price).toFixed(2)}
    </span>
  )}
</div>

                <button
                  className="text-white px-4 py-2 bg-[#c97c5d] rounded hover:bg-orange-300"
                  onClick={() => handleAddToCart(product.product_id)}
                >
                  View
                </button>
              </div>
            </div>
          ))}
        </div>
      </>
    )}

    {/* ⭐ FEATURED PRODUCTS */}
    {/* {featuredProducts.length > 0 && ( */}
    {showOnlyFeatured && featuredProducts.length > 0 && (
      <>
        <h2 className="text-3xl font-bold mb-8 text-center">
          Featured Products List
        </h2>

        {/* <div className="grid grid-cols-2 md:grid-cols-4 gap-6"> */}
       <div
  ref={scrollRef}
  className="flex gap-6 overflow-x-auto pb-4 scrollbar-hide"
>
          {/* {featuredProducts.map((product) => ( */}
          {/* {[...featuredProducts, ...featuredProducts].map((product, index) => (
            <div
              key={product.product_id}
              // className="bg-white rounded-lg shadow hover:shadow-xl transition ring-2 ring-yellow-400"
              className="min-w-[260px] max-w-[260px] bg-white rounded-lg shadow hover:shadow-xl transition ring-2 ring-yellow-400 flex-shrink-0"
            > */}
            {/* {[...featuredProducts, ...featuredProducts].map((product, index) => ( */}
            {featuredScrollProducts.map((product, index) => (
  <div key={`${product.product_id}-${index}`}
              className="min-w-[260px] max-w-[260px] bg-white rounded-lg shadow hover:shadow-xl transition ring-2 ring-yellow-400 flex-shrink-0"
  >
              <div className="relative">
                <div className="absolute top-2 left-2 bg-red-500 text-white text-xs font-bold px-2 py-1 rounded z-10">
                  Featured
                </div>

                <img
                  src={
                    product.image_file
                      ? `${baseURL}/uploads/${product.image_file}`
                      : "https://via.placeholder.com/300x200?text=No+Image"
                  }
                  alt={product.product_name}
                  className="w-full h-48 object-cover rounded-t-lg"
                />

                <div
                  className="absolute top-2 right-2 cursor-pointer z-10"
                  onClick={() => handleWishlist(product.product_id)}
                >
                  {likedProducts[product.product_id] ? (
                    <FaHeart size={24} className="text-red-500" />
                  ) : (
                    <CiHeart size={24} className="text-gray-500" />
                  )}
                </div>
              </div>

              <div className="p-4 text-center">
                <h3 className="text-sm font-medium text-center md:text-left px-2">
                  {product.product_name}
                </h3>

                {/* <p className="text-blue-600 font-bold mb-2">
                  ₹{getDisplayPrice(product)}
                </p> */}
                <div className="flex items-center justify-center gap-2 mb-2">
  {/* Selling Price */}
  <span className="text-blue-600 font-bold">
    ₹{Number(product.unit_selling_price || 0).toFixed(2)}
  </span>

  {/* MRP Price */}
  {product.mrp_price && (
    <span className="text-red-500 text-sm line-through">
      ₹{Number(product.mrp_price).toFixed(2)}
    </span>
  )}
</div>

                <button
                  className="text-white px-4 py-2 rounded bg-[#c97c5d] hover:bg-orange-300"
                  onClick={() => handleAddToCart(product.product_id)}
                >
                  View
                </button>
              </div>
            </div>
          ))}
        </div>
      </>
    )}
  </div>
);
};

export default Demo_3;